import { network } from 'services/network';

export const modifyClustersList = (params) => {
    return network.post('api/bo/modifyClustersList', params).then((response) => response.data);
};
